// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.payment.NarrowedPaymentDashboardSearchRequest */
/* istanbul ignore next */
@GandalfModel
export class NarrowedPaymentDashboardSearchRequest extends GandalfModelBase {

	@GandalfLabel('Payment Date End')
	@GandalfValidator({ notNull: { message: 'Payment Date End is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	endDate!: Date;

	@GandalfLabel('Payer Name')
	@GandalfValidator({ sizeString: { fieldLabel: 'Payer Name', maxLength: 1000, minLength: 0, message: 'Payer Name must be less than or equal to 1000 characters' } })
	@GandalfProperty({ designType: String })
	payerName!: string | null;

	@GandalfConstantDecorator(constants.PayerType)
	@GandalfLabel('Payer Type')
	@GandalfValidator({ notNull: { message: 'Payer Type is required' } })
	@GandalfProperty({ designType: constants.PayerType, isRequired: true })
	payerType!: constants.PayerType;

	@GandalfConstantDecorator(constants.PaymentMethodType)
	@GandalfLabel('Payment Method')
	@GandalfProperty({ designType: constants.PaymentMethodType })
	paymentMethodType!: constants.PaymentMethodType | null;

	@GandalfConstantDecorator(constants.PaymentSearchStatus)
	@GandalfLabel('Status')
	@GandalfValidator({ notNull: { message: 'Status is required' } })
	@GandalfProperty({ designType: constants.PaymentSearchStatus, isRequired: true })
	paymentSearchStatus!: constants.PaymentSearchStatus;

	@GandalfLabel('Location')
	@GandalfProperty({ designType: Number })
	practiceLocationId!: number | null;

	@GandalfConstantDecorator(constants.PaymentGroupSourceTypeSearch)
	@GandalfLabel('Payment Source')
	@GandalfProperty({ designType: constants.PaymentGroupSourceTypeSearch })
	sourceTypeSearch!: constants.PaymentGroupSourceTypeSearch | null;

	@GandalfLabel('Payment Date Start')
	@GandalfValidator({ notNull: { message: 'Payment Date Start is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	startDate!: Date;

}
